import { createFileRoute } from "@tanstack/react-router";
import Page from "@project/admin/pages/system/staff-roles";

export const Route = createFileRoute("/admin/_system/staff-roles")({
  component: Page,
});
